export default __webpack_public_path__ + "static/media/bg.bc536376.png";